import { render, staticRenderFns } from "./service3.vue?vue&type=template&id=08b41f8c&scoped=true&"
import script from "./service3.vue?vue&type=script&lang=js&"
export * from "./service3.vue?vue&type=script&lang=js&"
import style0 from "./service3.vue?vue&type=style&index=0&id=08b41f8c&prod&scoped=true&lang=css&"
import style1 from "./service3.vue?vue&type=style&index=1&id=08b41f8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b41f8c",
  null
  
)

export default component.exports